import { FieldFactory, Resource } from '@/classes';
import { Department, departmentPayloadSchema } from '@/types';

export default function departments() {
  return new Resource<Department>('Departments')
    .withSchema(departmentPayloadSchema)
    .getSubtitleUsing((d) => d.set?.name)
    .withFieldsAndColumns([FieldFactory.text('name')]);
}
